module.exports = __webpack_public_path__ + "b698a834f12c415da8c07904337e5d05.ttf";